const scheduleDemoFeedBack = [
    {
      pageImg: "/Images/scheduleDemo/schedule_demo_pop_up.png",
      pageAlt: "One of Ziggys helpers will be in contact with you soon",
    },
  ];
  
  export default scheduleDemoFeedBack;